import React from "react"
import {
  ActivityIndicator as RNActivityIndicator,
  ActivityIndicatorProps,
} from "react-native"

export function ActivityIndicator(props: ActivityIndicatorProps) {
  return <RNActivityIndicator {...props} color="#B71E3F" />
}
